export default {
	changePassword: {
		'Change Password': 'Change Password',
		'Set Password': 'Set Password',
	},
	profile: {
		绑定手机号: 'Bind phone',
		绑定邮箱: 'Bind email',
		裁剪人脸: 'Crop face photo',
		裁剪要求: 'Cropping rules',
		查看认证信息: 'View',
		查看原因: 'View reason',
		城市: 'City',
		待审核: 'Pending review',
		当前: 'Current',
		当前尺寸: 'Current size',
		地址: 'Address',
		点击认证: 'Verify',
		二要素认证: '2-Factor verification',
		二要素说明: 'Verify that name matches the ID number',
		放大: 'Zoom in',
		分辨率太低: 'Resolution too low, at least 480 × 640 pixels required',
		更换手机号: 'Change phone',
		更换邮箱: 'Change email',
		公司名称: 'Company',
		'国家/地区': 'Country / region',
		基本信息: 'Profile',
		仅支持jpg_png_webp: 'Only jpg / png / webp format is supported',
		仅支持PNG_JPG_JPEG: 'Only PNG / JPG / JPEG formats are supported',
		拒绝原因: 'Rejection reason',
		开始扫脸认证: 'Start face verification',
		请上传人脸图片: 'Please upload a face photo',
		请填写18位身份证号: 'Please enter your ID number',
		请填写本人实名手机号: 'Please enter your verified phone number',
		请填写有效的11位手机号: 'Please enter a valid 11-digit phone number',
		请填写有效的18位身份证号: 'Please enter a valid 18-digit ID number',
		请填写有效的手机号: 'Please enter a valid phone number',
		请填写真实姓名: 'Please enter your real name',
		去认证: 'Verify now',
		人脸说明:
			'Upload a clear front-facing PNG / JPG / JPEG photo with good lighting and no obstructions; cropped output is a 3:4 portrait, auto-compressed to under 1MB',
		人脸图片: 'Face photo',
		认证成功: 'Verification succeeded',
		认证类型: 'Verification type',
		认证失败: 'Verification failed',
		认证信息: 'Verification',
		若窗口未自动打开请点击: 'If the window did not open automatically, click',
		三要素认证: '3-Factor verification',
		三要素说明: 'Verify that name, ID number, and phone number all match',
		扫脸初始化失败: 'Face verification init failed',
		扫脸认证: 'Face verification',
		扫脸说明:
			'Click below to open the Alibaba Cloud face-scan page in a new window. After completing the scan, return here and click "I have completed the scan"',
		扫脸跳转说明: 'Face scan page opened in a new window. After completing, click "I have completed the scan"',
		身份证号: 'ID number',
		审核不通过: 'Rejected',
		审核中提示: 'Your information is under review, please wait',
		实名认证: 'Identity verification',
		实名认证信息: 'ID details',
		实时预览: 'Live preview',
		手动打开扫脸页面: 'open face scan page manually',
		手机号: 'Phone number',
		缩小: 'Zoom out',
		提升认证等级: 'Click to upgrade',
		图片不能超过4MB: 'Image must be smaller than 4MB',
		图片仍超过1MB请重新裁剪: 'Cropped image still exceeds 1MB, please crop a smaller area',
		未绑定: 'Unbound',
		未认证: 'Unverified',
		未填写: 'Not provided',
		我已完成扫脸: 'I have completed the scan',
		无拒绝原因: 'Administrator did not provide a rejection reason',
		姓名: 'Name',
		修改基本信息: 'Edit profile',
		修改信息: 'Edit profile',
		要求: 'Required',
		要求_大小: 'Auto-compressed to under 1MB after crop',
		要求_分辨率: 'Resolution 480×640 ~ 1080×1920',
		要求_格式: 'Format: PNG / JPG / JPEG',
		要求_竖版: 'Height > Width (3:4 portrait locked)',
		已绑定: 'Bound',
		已认证: 'Verified',
		邮箱: 'Email',
		邮箱更换成功提示: 'Email changed successfully. Click OK to refresh the page.',
		邮箱未绑定: 'Email not bound',
		邮箱已绑定: 'Email verified',
		邮政编码: 'Postal code',
		右转: 'Rotate right',
		语言: 'Language',
		预估大小: 'Est. file size',
		原图不能超过10MB: 'Original image must be smaller than 10MB',
		重新认证: 'Verify again',
		重新填写: 'Refill',
		重置: 'Reset',
		左转: 'Rotate left',
	},
	城市: 'City',
	当前密码: 'Current password',
	地区: 'Region',
	地址: 'Address',
	地址信息: 'Address',
	登录信息: 'Login details',
	电话号码: 'Phone',
	电话前缀: 'Country code',
	电话前缀和手机号不能为空: 'Country code and mobile are required',
	发送: 'Send',
	发送验证码: 'Send code',
	个人签名: 'Signature',
	个人资料: 'Account',
	更换: 'Change',
	更换邮箱: 'Change email',
	公司名称: 'Company',
	关闭: 'Close',
	国家: 'Country',
	'国家/地区': 'Country / region',
	获取验证码: 'Get code',
	基本信息: 'Profile',
	旧密码: 'Current password',
	联系方式: 'Contact',
	密码: 'Password',
	秒: 's',
	名字: 'First name',
	取消: 'Cancel',
	'确定提交吗？': 'Submit?',
	确认密码: 'Confirm password',
	生日: 'Birthday',
	手机号: 'Mobile',
	提交: 'Submit',
	退出登录: 'Sign out',
	完成: 'Done',
	未验证: 'Unverified',
	下一步: 'Next',
	新密码: 'New password',
	新密码不能与旧密码相同: 'New password must differ from the old one',
	确认密码与密码不一致: 'Confirm password must match the password',
	新邮箱地址: 'New email',
	新邮箱认证: 'Verify new email',
	新邮箱验证码: 'Email code',
	信息认证: 'Verification',
	姓氏: 'Last name',
	性别: 'Gender',
	修改或完善资料: 'Edit profile',
	验证: 'Verify',
	验证码: 'Verification code',
	已验证: 'Verified',
	邮箱地址: 'Email',
	'邮箱更换成功，请退出系统重新登录': 'Email updated. Please sign out and sign in again.',
	邮箱认证: 'Email verification',
	邮政编码: 'Postal code',
	语言: 'Language',
	重复密码: 'Confirm password',
	重复新密码: 'Confirm new password',
	最后登录时间: 'Last login',
	最后登录IP: 'Last IP',
}
